function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.83691 11.3372C2.83691 6.28854 6.95488 2.2041 12.0244 2.2041C17.0939 2.2041 21.2119 6.28854 21.2119 11.3372C21.2119 12.6677 20.9252 13.9335 20.4094 15.0754C20.288 15.344 20.0206 15.5166 19.7259 15.5166H12.6636C12.4366 15.5166 12.2218 15.4138 12.0795 15.237L9.74779 12.3412H3.59071C3.18525 12.3412 2.85319 12.0189 2.84105 11.6137C2.8383 11.5218 2.83691 11.4296 2.83691 11.3372ZM4.35289 10.8412H10.1068C10.3338 10.8412 10.5486 10.944 10.691 11.1208L13.0226 14.0166H19.2252C19.5397 13.1836 19.7119 12.2811 19.7119 11.3372C19.7119 7.12611 16.2747 3.7041 12.0244 3.7041C7.9423 3.7041 4.61018 6.86068 4.35289 10.8412Z",
  fill: "#222222"
});

var _ref3 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 14.3682,
  cy: 11.6729,
  rx: 1.21875,
  ry: 1.21875,
  fill: "#EB4C60"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M13.1494 16.2666C13.5636 16.2666 13.8994 16.6024 13.8994 17.0166V20.9541C13.8994 21.3683 13.5636 21.7041 13.1494 21.7041C12.7352 21.7041 12.3994 21.3683 12.3994 20.9541V17.0166C12.3994 16.6024 12.7352 16.2666 13.1494 16.2666Z",
  fill: "#FFDC60"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M18.2119 17.0166C18.2119 16.6024 17.8761 16.2666 17.4619 16.2666C17.0477 16.2666 16.7119 16.6024 16.7119 17.0166C16.7119 17.9486 15.9564 18.7041 15.0244 18.7041C14.6102 18.7041 14.2744 19.0399 14.2744 19.4541C14.2744 19.8683 14.6102 20.2041 15.0244 20.2041C16.7848 20.2041 18.2119 18.777 18.2119 17.0166Z",
  fill: "#B9FF60"
});

function SvgHelmet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelmet);
export default __webpack_public_path__ + "static/media/helmet.33915aed.svg";
export { ForwardRef as ReactComponent };